<template>
  <b-modal id="addProds" ref="modal" body-class="px-0 py-0" :ok-only="true" ok-title="Подтвердить" @hidden="modalClosed">
    <template v-if="product && allDops">
      <b-card>
        <template slot="header"><b>Добавленные допы:</b></template>
        <b-card-group class="grid grid-3 products pb-1" id="dop-added">
          <b-card no-body class="text-center my-1 prod prod-added"
                  v-for="prod in addedAdditionalProducts" :key="prod.index"
                  @click="product.groupProds.splice(product.groupProds.indexOf(prod), 1)">
            <div :id="'prod' + prod.id"
                 class="px-1 py-1 d-flex flex-column h-100 justify-content-center">
              <div>{{prod.name}}</div>
              <div class="sub-info">{{prod.cost}} &#8381;</div>
            </div>
          </b-card>
        </b-card-group>
      </b-card>
      <b-card>
        <template slot="header"><b>Все допы:</b></template>
        <b-card-group class="grid grid-3 products  pb-1" id="dop-all">
          <b-card no-body class="text-center my-1 prod"
                  @click="addAdditionalProduct(prod)"
                  v-for="prod in allDops.get(product.prod ? product.prod.idCategory : product.idCategory)"
                  :key="prod.id">
            <div :id="'prod' + prod.id"
                 class="px-1 py-1 d-flex flex-column h-100 justify-content-center">
              <div>{{prod.name}}</div>
              <div class="sub-info">{{prod.cost}} &#8381;</div>
            </div>
          </b-card>
        </b-card-group>
      </b-card>
    </template>
  </b-modal>
</template>

<script>
import {callCenterMUT} from '../../constants/vuexMutations'

export default {
  name: 'AddAdditional',
  data: () => {
    return {

    }
  },
  created () {
    this.switchModalAdditionalProducts(false)
  },
  props: {
    vuexNamespace: {
      type: String
    },
    showed: {
      type: Boolean
    },
    product: {
      type: Object
    },
    allDops: {
      type: Map
    }
  },
  computed: {
    addedAdditionalProducts () {
      // console.log(this.product.groupProds)
      return this.product.groupProds
    }
  },
  methods: {
    addAdditionalProduct (product) {
      if (!Array.isArray(this.product.groupProds)) {
        this.$set(this.product, 'groupProds', [])
      }
      this.product.groupProds.push(product)
      this.product.group = this.product.groupProds.map(item => item.id).join('|')
    },
    modalClosed () {
      this.switchModalAdditionalProducts(false)
    },
    switchModalAdditionalProducts (newState) {
      this.$store.commit(`${this.vuexNamespace}/${callCenterMUT.SWITCH_MODAL_ADDITIONAL_PRODUCT}`, newState)
    }
  },
  watch: {
    showed (value) {
      if (value) {
        this.$refs.modal.show()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .products {
    > .prod {
      cursor: pointer;
      > :hover {
        background: #DBEAB4;
      }
    }
    > .prod-added {
      background: #DBEAB4;
      > :hover {
        background: #EA6857;
        color: #fff;
      }
    }

  }
  .grid {
    display: grid;
  }

  .grid-3 {
    grid-template-columns: repeat(3, 1fr);
    > .card:nth-child(3n + 1) {
      border-left: 1px solid rgba(0, 0, 0, 0.125);;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/AddAdditionalProducts.vue